export const isAncienPatient = (patient) => !!(patient.seen || patient.former_patient);
export const isNouveauPatient = (patient) => !isAncienPatient(patient);
//# sourceMappingURL=ancienPatient.js.map